import { ReactNode, useState } from 'react';
import { Navigate, useLocation } from 'react-router';
import useAuth from '../hooks/useAuth';
import { PATH_AUTH, PATH_DASHBOARD } from '../routes/paths';
import {
  capturePendingAuthorization,
  getPendingAuthorization
} from '../utils/pendingAuthorization';

type GuestGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticated } = useAuth();
  const { search } = useLocation();
  const [hasPendingAuthorization] = useState(() => {
    capturePendingAuthorization(search);
    return getPendingAuthorization() !== null;
  });

  if (isAuthenticated) {
    return <Navigate to={hasPendingAuthorization ? PATH_AUTH.authorize : PATH_DASHBOARD.root} />;
  }

  return <>{children}</>;
}
